import CollapsibleActionMenu from '@/components/CollapsibleActionMenu';
import { ListItemIcon } from '@mui/material';
import { Edit as EditIcon } from '@mui/icons-material';
import { FormattedMessage } from 'react-intl';
import { type ActionMenuButtonProps } from '@/components/CollapsibleActionMenu/ActionMenuButton';

type EditSectionNameButtonProps = Omit<ActionMenuButtonProps, 'children'>;

const EditSectionNameButton = (props: EditSectionNameButtonProps) => (
  <CollapsibleActionMenu.Button {...props}>
    <ListItemIcon>
      <EditIcon />
    </ListItemIcon>
    <FormattedMessage id="editor.model_editor.actions.edit_name" />
  </CollapsibleActionMenu.Button>
);

export default EditSectionNameButton;
